import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  MenuItem,
  Switch,
  FormControlLabel,
  Snackbar,
  Alert
} from "@mui/material";

const EnterpriseMail = () => {
  const [empresa, setEmpresa] = useState({
    id: null,
    smtp_host: "",
    smtp_port: "",
    smtp_user: "",
    smtp_password: "",
    smtp_from_name: "",
    smtp_security: "SSL",
    smtp_use_custom_config: false
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: ""
  });

  const getCSRFToken = () => {
    const name = "csrftoken=";
    const cookies = decodeURIComponent(document.cookie || "").split(";");
    for (let c of cookies) {
      const t = c.trim();
      if (t.indexOf(name) === 0) return t.substring(name.length);
    }
    return "";
  };

  useEffect(() => {
    fetch("/facturas/empresa/obtener/", { credentials: "include" })
      .then((r) => r.json())
      .then((data) => {
        if (data?.empresa) {
          const e = data.empresa;
          setEmpresa({
            id: e.id,
            smtp_host: e.smtp_host || "",
            smtp_port: e.smtp_port || "",
            smtp_user: e.smtp_user || "",
            smtp_password: e.smtp_password || "",
            smtp_from_name: e.smtp_from_name || "",
            smtp_security: e.smtp_security || "SSL",
            smtp_use_custom_config: !!e.smtp_use_custom_config
          });
        }
      })
      .catch(() => {});
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmpresa((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitch = (e) => {
    const { name, checked } = e.target;
    setEmpresa((prev) => ({ ...prev, [name]: checked }));
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!empresa.id) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Primero debe registrar la empresa."
      });
      return;
    }

    try {
      const res = await fetch(`/facturas/empresa/editar/${empresa.id}/`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCSRFToken()
        },
        body: JSON.stringify({
          smtp_host: empresa.smtp_host,
          smtp_port: empresa.smtp_port,
          smtp_user: empresa.smtp_user,
          smtp_password: empresa.smtp_password,
          smtp_from_name: empresa.smtp_from_name,
          smtp_security: empresa.smtp_security,
          smtp_use_custom_config: empresa.smtp_use_custom_config
        })
      });

      const data = await res.json();

      if (res.ok) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Configuración SMTP guardada correctamente"
        });
      } else {
        setSnackbar({
          open: true,
          severity: "error",
          message:
            typeof data?.error === "string"
              ? data.error
              : Object.values(data.error || {})
                  .flat()
                  .join(" ")
        });
      }
    } catch {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Error de conexión con el servidor"
      });
    }
  };

  return (
    <Paper
      sx={{
        p: 4,
        borderRadius: "12px",
        boxShadow: "0 6px 18px rgba(0,0,0,0.1)"
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          color: "#1565C0",
          mb: 3
        }}
      >
        Configuración de Correo Empresarial
      </Typography>

      <Box component="form" onSubmit={submit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={empresa.smtp_use_custom_config}
                  onChange={handleSwitch}
                  name="smtp_use_custom_config"
                />
              }
              label="Usar servidor SMTP personalizado"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Servidor SMTP"
              name="smtp_host"
              fullWidth
              value={empresa.smtp_host}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Puerto SMTP"
              name="smtp_port"
              fullWidth
              value={empresa.smtp_port}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Correo remitente"
              name="smtp_user"
              fullWidth
              value={empresa.smtp_user}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Nombre del remitente"
              name="smtp_from_name"
              fullWidth
              value={empresa.smtp_from_name}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Contraseña SMTP"
              name="smtp_password"
              type="password"
              fullWidth
              value={empresa.smtp_password}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              select
              label="Seguridad SMTP"
              name="smtp_security"
              fullWidth
              value={empresa.smtp_security}
              onChange={handleChange}
            >
              <MenuItem value="SSL">SSL</MenuItem>
              <MenuItem value="TLS">TLS</MenuItem>
              <MenuItem value="NONE">NINGUNO</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                backgroundColor: "#1565C0",
                "&:hover": { backgroundColor: "#0D47A1" },
                textTransform: "none",
                fontWeight: 600
              }}
            >
              Guardar configuración
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Paper>
  );
};

export default EnterpriseMail;